import { jsx as _jsx } from "react/jsx-runtime";
import { FormHelperText as BaseFormHelperText, forwardRef, useColorMode, } from '@chakra-ui/react';
import { theme } from '../../../modules/theme';
export const FormWarningMessage = forwardRef((props, ref) => {
    const { colorMode } = useColorMode();
    return _jsx(BaseFormHelperText, { ref: ref, color: theme.colors[colorMode].text.warning, ...props });
});
